import React from 'react';
import styled, { ThemeConsumer } from 'styled-components';
import AnnexesIconSelector from '../../../../../../common/src/components/AnnexesIconSelector';

// Types
import { Annex } from '../../../../../../../types/SMT';
import { useTranslation } from 'react-i18next';
import { mq } from '../../../../../../common/src/utils/styledComponentsUtils';

interface Props {
  annex: Annex;
  onClick: () => void;
}

const AnnexDisplay: React.FC<React.PropsWithChildren<Props>> = ({
  annex,
  onClick,
}) => {
  const { t } = useTranslation();
  return (
    <ThemeConsumer>
      {(theme) => (
        <Wrapper onClick={onClick} data-test-id="ProdFac_AnnexDisplay">
          <IconWrapper>
            <AnnexesIconSelector type={annex.type} color={theme.primary[500]} />
          </IconWrapper>
          <BuildingTypeLabel data-test-id="ProdFac_AnnexDisplay_BuildingType">
            {t(annex?.type || '')}
          </BuildingTypeLabel>
          <GroundSurfaceLabel data-test-id="ProdFac_AnnexDisplay_GroundSurface">
            {annex?.surface} m²
          </GroundSurfaceLabel>
        </Wrapper>
      )}
    </ThemeConsumer>
  );
};

const BuildingTypeLabel = styled.p`
  font-size: 1.8rem;
  line-height: 120%;
  flex-grow: 1;

  ${mq.mobileL} {
    font-size: 1.6rem;
    text-align: center;
    flex-grow: 0;
  }
`;

const GroundSurfaceLabel = styled.p`
  font-size: 2.1rem;
  line-height: 160%;
  text-align: center;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 5rem;
  height: 5rem;
  border-radius: 2.5rem;
  background-color: ${({ theme }) => theme.primary[100]};
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  color: #31263d;

  > div,
  p {
    margin-right: 1.6rem;

    &:last-child {
      margin-right: 0;
    }
  }

  ${mq.mobileL} {
    flex-direction: column;

    > div:first-child {
      margin-bottom: 1.6rem;
    }

    > div:last-child {
      margin-top: 0.8rem;
    }
  }
`;

export default AnnexDisplay;
